<template>
  <div class="routes-page">
    <div class="page-header">
      <h2>线路列表</h2>
      <div class="header-actions">
        <el-button type="primary" @click="handleCreate">
          <i class="el-icon-plus"></i> 创建线路
        </el-button>
      </div>
    </div>
    <div class="routes-container">
      <el-table :data="routes" style="width: 100%" v-loading="loading" border>
        <el-table-column label="线路名称" min-width="250">
          <template slot-scope="scope">
            <div class="route-info">
              <div class="route-image" v-if="scope.row.image">
                <img :src="scope.row.image" :alt="scope.row.productName" />
              </div>
              <div class="route-detail">
                <span class="route-name">{{ scope.row.productName }}</span>
                <span class="route-id">{{ scope.row.idText }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="难度" width="60">
          <template slot-scope="scope">
            {{ scope.row.difficultyName }}
          </template>
        </el-table-column>

        <el-table-column label="价格" width="80">
          <template slot-scope="scope">
            <span class="price">¥{{ scope.row.basePrice }}</span>
          </template>
        </el-table-column>

        <el-table-column label="出发时间" width="100">
          <template slot-scope="scope">
            {{ scope.row.recentDepartureDate | formatDate }}
          </template>
        </el-table-column>

        <el-table-column label="目的地" min-width="220">
          <template slot-scope="scope">
            {{
              scope.row.destProvinceName +
              ' ' +
              scope.row.destCityName +
              scope.row.destDistrict
            }}
          </template>
        </el-table-column>

        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              icon="el-icon-view"
              @click="viewRoute(scope.row)"
            >
              查看
            </el-button>
            <el-button
              size="small"
              type="text"
              icon="el-icon-edit"
              @click="editRoute(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="scope.row.status === 1"
              size="small"
              type="text"
              icon="el-icon-download"
              @click="handleOffline(scope.row)"
            >
              下架
            </el-button>
            <el-button
              v-else-if="scope.row.status === 0 || scope.row.status === 2"
              size="small"
              type="text"
              icon="el-icon-upload2"
              @click="handleOnline(scope.row)"
            >
              上架
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="pagination-info"
          >显示第 {{ (currentPage - 1) * pageSize + 1 }} 至
          {{ Math.min(currentPage * pageSize, total) }} 条，共
          {{ total }} 条记录</span
        >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Routes',
  data() {
    return {
      productName: '',
      currentPage: 1,
      pageSize: 5,
      total: 0,
      loading: false,
      routes: []
    }
  },
  mounted() {
    // 页面加载后自动调用获取线路列表接口
    this.fetchRoutes()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchRoutes()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchRoutes()
    },
    handleCreate() {
      this.$router.push({ path: '/route-form', query: { type: '1' } })
    },
    viewRoute(route) {
      this.$router.push({
        path: '/route-form',
        query: { type: '3', productId: route.productId }
      })
    },
    editRoute(route) {
      this.$router.push({
        path: '/route-form',
        query: { type: '2', productId: route.productId }
      })
    },
    handleSearch() {
      this.fetchRoutes()
    },
    async fetchRoutes() {
      this.loading = true
      try {
        const res = await this.$http.post('product/getProductList.do', {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          productName: this.productName
        })

        // 根据 axios 响应拦截器，code 为 '0' 或 0 表示成功
        if (res.code === '0' || res.code === 0) {
          // 根据实际接口返回结构调整数据赋值逻辑
          this.routes = res.result || []
          // 如果接口返回总条数，也需要同步更新 total
          this.total = res.total || 0
        } else {
          this.$message.error(res.message || '获取列表失败')
        }
      } catch (error) {
        console.error('获取线路列表错误:', error)
        this.$message.error('网络请求异常')
      } finally {
        this.loading = false
      }
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '下架',
        1: '上架',
        2: '待发布'
      }
      return statusMap[status] || '未知'
    },
    // 获取状态标签类型
    getStatusType(status) {
      const typeMap = {
        0: 'danger', // 下架 - 红色
        1: 'success', // 上架 - 绿色
        2: 'warning' // 待发布 - 橙色
      }
      return typeMap[status] || ''
    },
    // 下架处理
    handleOffline(route) {
      this.$confirm('确定要下架该线路吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await this.$http.post(
              'product/updateProductStatus.do',
              {
                productId: route.productId || route.id,
                status: 0
              }
            )

            if (res.code === '0' || res.code === 0) {
              this.$message.success('下架成功')
              this.fetchRoutes()
            } else {
              this.$message.error(res.message || '下架失败')
            }
          } catch (error) {
            console.error('下架错误:', error)
            this.$message.error('网络请求异常')
          }
        })
        .catch(() => {
          this.$message.info('已取消下架')
        })
    },
    // 上架处理
    async handleOnline(route) {
      try {
        const res = await this.$http.post('product/updateProductStatus.do', {
          productId: route.productId || route.id,
          status: 1
        })

        if (res.code === '0' || res.code === 0) {
          this.$message.success('上架成功')
          this.fetchRoutes()
        } else {
          this.$message.error(res.message || '上架失败')
        }
      } catch (error) {
        console.error('上架错误:', error)
        this.$message.error('网络请求异常')
      }
    }
  }
}
</script>

<style scoped>
.routes-page {
  padding: 20px 24px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 80px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-input {
  width: 260px;
  border-radius: 8px;
}

.search-input .el-input__inner {
  border-radius: 8px;
  padding: 8px 12px;
}

.create-btn {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 500;
}

.create-btn:hover {
  background: linear-gradient(135deg, #15803d 0%, #166534 100%);
}

.routes-container {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  padding: 20px;
}

/* Element UI 表格样式优化 */
.routes-container ::v-deep .el-table {
  font-size: 14px;
}

.routes-container ::v-deep .el-table th {
  background-color: #f9fafb;
  color: #6b7280;
  font-weight: 600;
}

.routes-container ::v-deep .el-table td {
  padding: 12px 0;
}

.route-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.route-image {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f3f4f6;
}

.route-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.route-detail {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.route-name {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
}

.route-id {
  font-size: 12px;
  color: #9ca3af;
}

.difficulty-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  min-width: 48px;
}

.difficulty-tag.easy {
  background-color: #f0fdf4;
  color: #22c55e;
}

.difficulty-tag.simple {
  background-color: #f0f9ff;
  color: #3b82f6;
}

.difficulty-tag.medium {
  background-color: #fffbeb;
  color: #f59e0b;
}

.difficulty-tag.hard {
  background-color: #fef2f2;
  color: #ef4444;
}

.price {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-top: 1px solid #f0f0f0;
  background-color: #fafafa;
}

.pagination-info {
  font-size: 13px;
  color: #6b7280;
}

.pagination .el-pagination {
  margin: 0;
}

.pagination .el-pagination button {
  border-radius: 6px;
}

.pagination .el-pagination .el-pager li.active {
  background-color: #22c55e;
  border-color: #22c55e;
  color: #fff;
}

.pagination .el-pagination .el-pager li.active:hover {
  background-color: #16a34a;
}

/* 状态标签样式强制覆盖 */
.el-tag--danger {
  background-color: #fef2f2 !important;
  color: #dc2626 !important;
  border-color: #fecaca !important;
}

.el-tag--success {
  background-color: #f0fdf4 !important;
  color: #16a34a !important;
  border-color: #bbf7d0 !important;
}

.el-tag--warning {
  background-color: #fffbeb !important;
  color: #d97706 !important;
  border-color: #fde68a !important;
}

/* 操作按钮点击后状态样式 */
.el-button--text:focus,
.el-button--text:active {
  color: #606266 !important;
  background-color: transparent !important;
}
</style>
